import { Alert } from '@cvpartner/design-system';
import type React from 'react';
import { I18n } from 'util/translations';
import { Login } from './Login';

export const UnblockLoginReceipt: React.FC = () => (
  <Login
    alert={
      <Alert
        type="success"
        title={I18n.t('unblocked.alert.success')}
        description={I18n.t('unblocked.alert.success_msg_signin')}
      />
    }
    type="normal"
  />
);
